import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollManager from './components/ScrollManager';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import Home from './pages/Home';
import Calendar from './pages/Calendar';
import StudyPlan from './pages/StudyPlan';
import ProfileBuilder from './pages/ProfileBuilder';
import AdmissionsChatbot from './pages/AdmissionsChatbot';
import EssayBuilder from './pages/EssayBuilder';
import ResumeReview from './pages/ResumeReview';
import SchoolIntel from './pages/SchoolIntel';
import SchoolComparison from './pages/SchoolComparison';
import OddsCalculator from './pages/OddsCalculator';
import Blog from './pages/Blog';
import DeferredForumPage from './pages/Forum';
import ApplicationPortal from './pages/ApplicationPortal';
import Roadmap from './pages/Roadmap';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AccountPage from './pages/AccountPage';
import Support from './pages/Support';
import Legal from './pages/Legal';
import Privacy from './pages/Privacy';
import ChatbotWidget from './components/ChatbotWidget';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollManager />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/study-plan" element={<StudyPlan />} />
            <Route path="/profile-builder" element={<ProfileBuilder />} />
            <Route path="/admissions-chatbot" element={<AdmissionsChatbot />} />
            <Route path="/essay-builder" element={<EssayBuilder />} />
            <Route path="/resume-review" element={<ResumeReview />} />
            <Route path="/school-intel" element={<SchoolIntel />} />
            <Route path="/odds-calculator" element={<OddsCalculator />} />
            <Route path="/school-comparison" element={<SchoolComparison />} />
            <Route path="/application-portal" element={<ApplicationPortal />} />
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Blog />} />
            <Route path="/forum" element={<DeferredForumPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/support" element={<Support />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <AccountPage />
                </ProtectedRoute>
              }
            />
          </Routes>
          <ChatbotWidget />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
